import { config } from '../config';
import axios from 'axios';
import Cookies from 'js-cookie';
import api from '../api';

export const signIn = async (data) => {
    return await axios.create({
        baseURL: config.baseUrl,
        headers: {
            'Content-Type': 'application/json'
        }
    }).post(`/auth`, data);
}

export const logOut = async () => {

    return await new Promise((resolve) => {
        
        Cookies.remove('loggedIn');
        localStorage.removeItem("token");
        localStorage.removeItem("idUser");
        
        resolve();
    });
}

export const getUserConnected = async () => {
    return await api.get(`/connected/user`);
}

export const requestPassword = async (data) => {
    return await api.post(`/request-password`, data);
}

export const changePassword = async (data, token) => {
    return await api.post(`/change-password`, { ...data, token });
}